import api from "./api";

export default {
  async fetchTasks({ commit }, params = {}) {
    commit("SET_LOADING", true);
    try {
      const { items, meta } = await api.list(params);
      commit("SET_ITEMS", { items, meta });
      return items;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async createTask({ commit }, payload) {
    commit("SET_CREATING", true);
    try {
      const task = await api.create(payload);
      commit("UPSERT", task);
      return task;
    } finally {
      commit("SET_CREATING", false);
    }
  },

  async updateTask({ commit }, { id, ...payload }) {
    const task = await api.update(id, payload);
    commit("UPSERT", task);
    return task;
  },

  async completeTask({ commit }, id) {
    const task = await api.complete(id);
    commit("UPSERT", task);
    return task;
  },

  async reopenTask({ commit }, id) {
    const task = await api.reopen(id);
    commit("UPSERT", task);
    return task;
  },

  async stopTaskRecurrence({ commit }, id) {
    const task = await api.stopRecurrence(id);
    commit("UPSERT", task);
    return task;
  },

  async deleteTask({ commit }, id) {
    await api.remove(id);
    commit("REMOVE", id);
  },

  async fetchTaskUsers({ commit, state }) {
    if (state.usersLoaded) return state.users;
    const users = await api.users();
    commit("SET_USERS", users);
    return users;
  },
};
